import { useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import type { InspectionFinding } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionResultSchema'
import styled from 'styled-components'

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-top: 0.5rem;
  max-height: 10rem;
  overflow: auto;
`

export function InspectionFindingActions({
  findings,
  onSelect,
  limit = 8,
}: {
  findings: InspectionFinding[]
  onSelect: (finding: InspectionFinding) => void
  limit?: number
}) {
  const { t } = useLingui()
  const label = (index: number) => t`Low area ${index} · minimum reading`
  return (
    <Actions>
      {findings.slice(0, limit).map((finding) => (
        <Button
          key={finding.id}
          size='sm'
          variant='outline'
          onClick={() => onSelect(finding)}>
          {label(finding.index)}
        </Button>
      ))}
    </Actions>
  )
}
